import React from "react";

function Shipwreck() {
  return (
    <div className="gif-background">
      <img
        className="shipwreck"
        alt="Shipwreck GIF"
        src="./ocean/shipwreck.png"
        style={{ top: "65vh", left: "10vw" }}
      />
    </div>
  );
}

export default Shipwreck;
